import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { authAction, completeLoginAction } from '../../store/actions/';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from "react-intl";
import Notification from '../../components/Notification/Notification';
import NotificationSystem from 'react-notification-system';
import progressBar from "../../utils/progressBar";
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import api from '../../utils/api';
import setAuthorizationHeader from '../../utils/setAuthorizationHeader';

const ValidationSchema = Yup.object().shape({
    usr_code: Yup.string()
        .required(<FormattedMessage
            id="dashboard.User.Name.Required"
            defaultMessage='User name is required!' />),
    password: Yup.string()
        .required(<FormattedMessage
            id="dashboard.User.Password.Required"
            defaultMessage='Password is required!' />),
});

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                // usr_code: 'primarynet',
                // password: 'primarynet123',
                remember: false,
                usr_code: '',
                password: '',
            },
            notification: {
                allowHTML: false,
            },
            secondAuthModal: false,
            secondAuthLoading: false,
            secondAuthVerifying: false,
            secondAuthResending: false,
            secondAuthToken: '',
            secondAuthChallengeToken: '',
            secondAuthOtpCode: '',
            secondAuthMaskedPhone: '',
            secondAuthResendAfterSeconds: 0,
            secondAuthRemember: false,
            secondAuthUsrCode: '',
            isLoginSubmitting: false,
        };
        this.secondAuthTimer = null;
    }

    notificationSystem = React.createRef();
    addNotification = (data) => {
        const notification = this.notificationSystem.current;
        notification.addNotification({
            message: data.message,
            title: data.title,
            level: data.level
        });
    };

    deleteAllCookies = () => {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }


    _handleSubmit = (values, action) => {
        if (this.state.isLoginSubmitting) {
            return;
        }

        this.setState({ isLoginSubmitting: true });
        progressBar.start();
        this.props.onLogin(values).then(res => {
            if (res && res.requiresSecondAuth) {
                this.setState({
                    secondAuthModal: true,
                    secondAuthToken: res.token || '',
                    secondAuthMaskedPhone: res.masked_phone || '',
                    secondAuthRemember: !!values.remember,
                    secondAuthUsrCode: values.usr_code,
                    secondAuthOtpCode: '',
                    isLoginSubmitting: false,
                }, () => {
                    this.requestSecondAuthOtp();
                });
                progressBar.done();
                return;
            }

            if (values.remember) {
                localStorage.setItem('remember', values.usr_code);
            } else {
                localStorage.removeItem('remember')
            }
            // delete cookie
            // this.deleteAllCookies();
            // // delete cache
            // caches.keys().then(function(keyList) {
            //     console.log(keyList,'keyList')
            //     //do something with your keyList
            //     return Promise.all(keyList.map(function(key) {
            //         if(key){
            //             return caches.delete(key);
            //         }
            //     }));
            // });
            // console.log('delete cache and cookie')
            progressBar.done();
            this.setState({ isLoginSubmitting: false });
        })
            .catch(error => {
                if (error.data) {
                    this.addNotification({
                        title: <FormattedMessage
                            id="dashboard.Error"
                            defaultMessage="Error !" />,
                        message: error.data.errors.message,
                        level: 'error',
                    })

                } else {
                    this.addNotification({
                        title: <FormattedMessage
                            id="dashboard.Error"
                            defaultMessage="error !" />,
                        message: <FormattedMessage
                            id="dashboard.ErrorMessage"
                            defaultMessage="Sorry! Something wen't wrong. Retry!" />,
                        level: 'error',
                    })
                }
                progressBar.done();
                this.setState({ isLoginSubmitting: false });
            });
    };

    requestSecondAuthOtp = () => {
        if (this.state.secondAuthLoading) {
            return;
        }

        this.setState({
            secondAuthLoading: true
        });

        api.auth.requestSecondAuthOtp().then(response => {
            const data = response.data && response.data.data ? response.data.data : {};
            this.setState({
                secondAuthLoading: false,
                secondAuthChallengeToken: data.challenge_token || '',
                secondAuthMaskedPhone: data.masked_phone || this.state.secondAuthMaskedPhone,
            });
            this.startSecondAuthCountdown(data.resend_after_seconds || 0);
        }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.errors
                ? error.response.data.errors.message
                : '인증번호 요청에 실패했습니다.';

            this.setState({
                secondAuthLoading: false
            });
            this.addNotification({
                title: '2차 인증',
                message,
                level: 'error',
            });
        });
    };

    startSecondAuthCountdown = (seconds = 0) => {
        if (this.secondAuthTimer) {
            clearInterval(this.secondAuthTimer);
            this.secondAuthTimer = null;
        }

        const remainSeconds = Number(seconds) || 0;
        this.setState({
            secondAuthResendAfterSeconds: remainSeconds > 0 ? remainSeconds : 0
        });

        if (remainSeconds <= 0) {
            return;
        }

        this.secondAuthTimer = setInterval(() => {
            this.setState(prevState => {
                if (prevState.secondAuthResendAfterSeconds <= 1) {
                    clearInterval(this.secondAuthTimer);
                    this.secondAuthTimer = null;
                    return {
                        secondAuthResendAfterSeconds: 0
                    };
                }
                return {
                    secondAuthResendAfterSeconds: prevState.secondAuthResendAfterSeconds - 1
                };
            });
        }, 1000);
    };

    onChangeSecondAuthOtp = (event) => {
        const value = event.target.value ? event.target.value.replace(/\D/g, '').slice(0, 10) : '';
        this.setState({
            secondAuthOtpCode: value
        });
    };

    onResendSecondAuthOtp = () => {
        const { secondAuthChallengeToken, secondAuthResendAfterSeconds, secondAuthResending } = this.state;
        if (!secondAuthChallengeToken || secondAuthResendAfterSeconds > 0 || secondAuthResending) {
            return;
        }

        this.setState({
            secondAuthResending: true
        });

        api.auth.resendSecondAuthOtp(secondAuthChallengeToken).then(response => {
            const data = response.data && response.data.data ? response.data.data : {};
            this.setState({
                secondAuthResending: false
            });
            this.startSecondAuthCountdown(data.resend_after_seconds || 0);
            this.addNotification({
                title: '2차 인증',
                message: '인증번호를 재전송했습니다.',
                level: 'success',
            });
        }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.errors
                ? error.response.data.errors.message
                : '인증번호 재전송에 실패했습니다.';
            this.setState({
                secondAuthResending: false
            });
            this.addNotification({
                title: '2차 인증',
                message,
                level: 'error',
            });
        });
    };

    onVerifySecondAuthOtp = () => {
        const {
            secondAuthChallengeToken,
            secondAuthOtpCode,
            secondAuthToken,
            secondAuthRemember,
            secondAuthUsrCode,
            secondAuthVerifying
        } = this.state;

        if (secondAuthVerifying) {
            return;
        }

        if (!secondAuthOtpCode || secondAuthOtpCode.length < 4) {
            this.addNotification({
                title: '2차 인증',
                message: '인증번호를 입력해 주세요.',
                level: 'error',
            });
            return;
        }

        if (!secondAuthChallengeToken || !secondAuthToken) {
            this.addNotification({
                title: '2차 인증',
                message: '인증 세션 정보가 없습니다. 다시 로그인해 주세요.',
                level: 'error',
            });
            return;
        }

        this.setState({
            secondAuthVerifying: true
        });
        progressBar.start();

        api.auth.verifySecondAuthOtp({
            challenge_token: secondAuthChallengeToken,
            otp_code: secondAuthOtpCode,
        }).then(() => {
            return this.props.onCompleteLogin(secondAuthToken);
        }).then(() => {
            if (secondAuthRemember) {
                localStorage.setItem('remember', secondAuthUsrCode);
            } else {
                localStorage.removeItem('remember');
            }

            if (this.secondAuthTimer) {
                clearInterval(this.secondAuthTimer);
                this.secondAuthTimer = null;
            }

            this.setState({
                secondAuthModal: false,
                secondAuthVerifying: false,
                secondAuthToken: '',
                secondAuthChallengeToken: '',
                secondAuthOtpCode: '',
                secondAuthMaskedPhone: '',
                secondAuthResendAfterSeconds: 0,
            });
            progressBar.done();
        }).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.errors
                ? error.response.data.errors.message
                : '2차 인증에 실패했습니다.';

            this.setState({
                secondAuthVerifying: false
            });
            this.addNotification({
                title: '2차 인증',
                message,
                level: 'error',
            });
            progressBar.done();
        });
    };

    closeSecondAuthModal = () => {
        if (this.secondAuthTimer) {
            clearInterval(this.secondAuthTimer);
            this.secondAuthTimer = null;
        }

        setAuthorizationHeader();

        this.setState({
            secondAuthModal: false,
            secondAuthLoading: false,
            secondAuthVerifying: false,
            secondAuthResending: false,
            secondAuthToken: '',
            secondAuthChallengeToken: '',
            secondAuthOtpCode: '',
            secondAuthMaskedPhone: '',
            secondAuthResendAfterSeconds: 0,
            secondAuthRemember: false,
            secondAuthUsrCode: '',
        });
    }

    componentDidMount() {
        const remember = localStorage.getItem('remember');
        if (remember) {
            this.setState({
                form: {
                    usr_code: remember,
                    remember: true,
                }
            })
        }
    }

    componentWillUnmount() {
        if (this.secondAuthTimer) {
            clearInterval(this.secondAuthTimer);
            this.secondAuthTimer = null;
        }
    }

    render() {
        return (
            <Formik
                initialValues={this.state.form}
                enableReinitialize={true}
                validationSchema={ValidationSchema}
                // isInitialValid={false}
                onSubmit={(values, actions) => {
                    this._handleSubmit(values, actions);
                    // let { data } = values;
                    // this.setState({
                    //     ...values,
                    //     errors: {
                    //         ...values.errors,
                    //         atLeast: atLeastError,
                    //     }
                    // }, () => {
                    // })
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    isValid,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldTouched,
                }) => {
                    const {
                        secondAuthModal,
                        secondAuthLoading,
                        secondAuthVerifying,
                        secondAuthResending,
                        secondAuthOtpCode,
                        secondAuthMaskedPhone,
                        secondAuthResendAfterSeconds,
                        isLoginSubmitting
                    } = this.state;
                    return (
                        <Fragment>
                            <style>
                                {`
                                    .login-second-auth-backdrop.show {
                                        opacity: 0.82 !important;
                                        background-color: #000 !important;
                                    }
                                `}
                            </style>
                            <NotificationSystem ref={this.notificationSystem} />

                            <FormattedMessage id="login.login"
                                defaultMessage="Login">
                                {message => <Helmet>
                                    <title>{message}</title>
                                </Helmet>}
                            </FormattedMessage>
                            <div className="container-fluid">
                                <div className="row no-gutter">
                                    <div className="d-none d-md-flex col-md-4 col-lg-6 bg-image" />
                                    <div className="col-md-8 col-lg-6 bg-light">
                                        <div className="login d-flex align-items-center py-5">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-9 col-lg-8 mx-auto">
                                                        <h3 className="login-heading mb-4 text-center" style={{ fontSize: '30px', fontWeight: 700 }}>아톡비즈 분양CRM</h3>
                                                        <form onSubmit={handleSubmit}>
                                                            <div className="form-label-group">
                                                                <input
                                                                    placeholder="ID"
                                                                    className="form-control"
                                                                    id="inputID"
                                                                    type="text"
                                                                    name="usr_code"
                                                                    value={values.usr_code}
                                                                    onChange={handleChange}
                                                                    onBlur={() => setFieldTouched('usr_code')}
                                                                />
                                                                {touched.usr_code && errors.usr_code &&
                                                                    <span className="text-danger">{errors.usr_code}</span>
                                                                }

                                                                {/* <input type="id" id="inputID" className="form-control" placeholder="ID" required autofocus /> */}
                                                                <label htmlFor="inputID">ID</label>
                                                            </div>
                                                            <div className="form-label-group">
                                                                <input
                                                                    placeholder="Password"
                                                                    className="form-control"
                                                                    id="inputPassword"
                                                                    type="password"
                                                                    name="password"
                                                                    value={values.password}
                                                                    onChange={handleChange}
                                                                    onBlur={() => setFieldTouched('password')}
                                                                />
                                                                {touched.password && errors.password &&
                                                                    <span className="text-danger">{errors.password}</span>
                                                                }

                                                                {/* <input type="password" id="inputPassword" className="form-control" placeholder="Password" required /> */}
                                                                <label htmlFor="inputPassword">Password</label>
                                                            </div>
                                                            <div className="custom-control custom-checkbox mb-3">
                                                                <input
                                                                    className="custom-control-input"
                                                                    type="checkbox"
                                                                    name="remember"
                                                                    id="customCheck1"
                                                                    value={values.remember}
                                                                    onChange={handleChange}
                                                                    checked={values.remember}
                                                                />

                                                                {/* <input type="checkbox" className="custom-control-input" id="customCheck1" /> */}
                                                                <label className="custom-control-label" htmlFor="customCheck1">아이디 저장</label>
                                                            </div>
                                                            <button className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2" type="submit" disabled={isLoginSubmitting}>{isLoginSubmitting ? '로그인 중...' : '로그인'}</button>
                                                            <div className="text-center mt-4">
                                                                <img src="/crm_template/dist/images/icon/login.png" alt="" width="240px" /><br />
                                                                <a href="tel:1877-5271" style={{ fontSize: '26px', fontWeight: 700, fontFamily: '"oswald"' }}>1877-5271</a><br />
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Modal
                                isOpen={secondAuthModal}
                                backdrop="static"
                                keyboard={false}
                                backdropClassName="login-second-auth-backdrop"
                                centered
                            >
                                <ModalHeader toggle={this.closeSecondAuthModal}>2차 인증</ModalHeader>
                                <ModalBody>
                                    <p style={{ marginBottom: '10px', whiteSpace: 'pre-line', lineHeight: '1.5' }}>
                                        로그인 하시려는 계정은 2차 인증이 필요합니다. 계정 사용자분께서는 SMS로 수신된 인증번호를 입력 하시기를 요청부탁드립니다. 인증번호 입력시간이 초과 되거나, 세션이 변경된 경우는 다시 요청해 주세요.
                                    </p>
                                    {secondAuthMaskedPhone ? (
                                        <p style={{ marginBottom: '10px', fontSize: '13px' }}>
                                            발송번호: {secondAuthMaskedPhone}
                                        </p>
                                    ) : ''}
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={secondAuthOtpCode}
                                        onChange={this.onChangeSecondAuthOtp}
                                        placeholder="인증번호"
                                        disabled={secondAuthLoading || secondAuthVerifying}
                                    />
                                </ModalBody>
                                <ModalFooter>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={this.onResendSecondAuthOtp}
                                        disabled={secondAuthLoading || secondAuthResending || secondAuthResendAfterSeconds > 0}
                                    >
                                        {secondAuthResendAfterSeconds > 0
                                            ? `재전송 (${secondAuthResendAfterSeconds}s)`
                                            : (secondAuthResending ? '재전송 중...' : '재전송')}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={this.onVerifySecondAuthOtp}
                                        disabled={secondAuthLoading || secondAuthVerifying}
                                    >
                                        {secondAuthVerifying ? '확인 중...' : '인증 확인'}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        onClick={this.closeSecondAuthModal}
                                        disabled={secondAuthLoading || secondAuthVerifying}
                                    >
                                        확인
                                    </button>
                                </ModalFooter>
                            </Modal>

                        </Fragment>
                    )
                }}
            </Formik>
        )
    }
}

const mapStateToProps = state => {
    return {}
};

const mapDispatchToProps = dispatch => {
    return {
        onLogin: credentials => dispatch(authAction(credentials)),
        onCompleteLogin: token => dispatch(completeLoginAction(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
